import { BLUETOOTH_FILTER_PREFIX } from "./bluetoothConstants";

// The trap splits the "wpa" write as [length][ssid][psk], reading the length as a byte count
// ('0'-'9' for 0-9, 'a' onwards for 10 and up). It must be counted in UTF-8 bytes: ssid.length
// counts UTF-16 units, which differs for any non-ASCII SSID ("Craig’s iPhone", Korean names)
// and makes the trap cut the SSID and password in the wrong place.
export function ssidLengthPrefix(ssid: string): string {
  const byteLength = new TextEncoder().encode(ssid).length;
  return byteLength < 10
    ? String(byteLength)
    : String.fromCharCode("a".charCodeAt(0) + (byteLength - 10));
}

export function encodeWifiCredentials(ssid: string, psk: string): string {
  return ssidLengthPrefix(ssid) + ssid + psk;
}

export function extractDeviceNumber(deviceUuid: string = ""): string {
  const match = deviceUuid.match(/(\d+)$/);
  return match?.[1] || "";
}

export function buildDeviceFilters(
  deviceUuid: string = "",
): BluetoothLEScanFilter[] {
  const deviceNumber = extractDeviceNumber(deviceUuid);
  const filters: BluetoothLEScanFilter[] = [
    deviceNumber
      ? { name: BLUETOOTH_FILTER_PREFIX + deviceNumber }
      : { namePrefix: BLUETOOTH_FILTER_PREFIX },
  ];
  // Traps before the BlueZ alias fix advertise "Scout N" but serve BlueZ's system name as the GAP
  // device name. That is the pretty hostname, which provisioning sets to the device uuid. Once a
  // computer has connected it caches that name and the chooser shows it instead, so "Scout N"
  // alone hides the trap from that computer for good.
  if (deviceUuid) {
    filters.push({ name: deviceUuid });
  }
  return filters;
}

export type WifiScanResult = {
  ssids: string[];
  activeNetwork: string;
};

// Each scan chunk is "ssid$active$saved," repeated; the chunks concatenate into one list.
export function parseWifiScanChunks(chunks: string[]): WifiScanResult {
  let activeNetwork = "";
  const ssids = chunks
    .join("")
    .split(",")
    .map((entry) => {
      const [name, active] = entry.split("$");
      if (active === "1") {
        activeNetwork = name;
      }
      return name;
    })
    .filter((ssid) => !!ssid);
  return { ssids, activeNetwork };
}
